import CustomHelmet from "../../common/seo/customhelmet/CustomHelmet";
import SectionHeader from "../../common/components/SectionHeader";
import Typography from '@mui/material/Typography';

const Offline = () => {
    return (
        <div data-testid="OfflinePage" className="offline-page app-section">
            <CustomHelmet title="Offline" noIndex />
            <SectionHeader title="Offline" hidden />

            <div style={{ textAlign: 'center' }}>
                <Typography variant="h3">
                    It looks like you're offline, please check your internet connection and try again.
                </Typography>
            </div>
        </div>
    )
}

export default Offline;